import api from './api';

export const slaService = {
  getConfigs: () => api.get('/sla/configs'),
  updateConfig: (data) => api.put('/sla/configs', data),
};
